import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isDelegationSessionStatusLoading } from 'domains/delegation/DelegationSession.store';
import { getR1ClientConfig, subscribeR1NetworkRequestSaga } from 'domains/r1Network/R1Network.store';
import { getTradingProfile, getUserProfileSearchStatus, getUserRights, UserRole } from 'domains/user';
import { FOUND, getData, hasUserAnyRight } from 'utils';

export const useFetchR1NetworkClientConfig = (): void => {
  const dispatch = useDispatch();
  const userRights = useSelector(getUserRights);
  const searchStatus = useSelector(getUserProfileSearchStatus);
  const r1ClientConfig = useSelector(getR1ClientConfig);

  const tradingProfile = useSelector(getTradingProfile);
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);

  useEffect(() => {
    // all non-R1 users
    if (!hasUserAnyRight([UserRole.R2, UserRole.R3, UserRole.R3_MOTRIO], getData(userRights) ?? [])) {
      return;
    }
    if (isDelegationLoading) {
      return;
    }

    if (r1ClientConfig.searchStatus === undefined && searchStatus === FOUND && tradingProfile?.isComplete()) {
      dispatch(subscribeR1NetworkRequestSaga());
    }
  }, [dispatch, isDelegationLoading, r1ClientConfig, searchStatus, tradingProfile, userRights]);
};
